import styled from 'styled-components';

export const StyledVideoTrack = styled.video`
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
`;
